import Vue from 'vue'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import VueMask from 'v-mask'
import money from 'v-money'
import UUID from 'vue-uuid'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import './config/msgs'
import './config/axios'
import './config/mq'
import router from './config/router'
import store from './config/store'

Vue.config.productionTip = false
Vue.use(UUID)
Vue.use(CKEditor)
// Vue.use(DisableAutocomplete)
// Vue.use(VueCurrencyInput)
Vue.use(VueMask)
Vue.use(money, { precision: 2 })
Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
